// Trips.jsx
import React, { useEffect, useState } from "react";
import { deleteTrip, getAllTrips } from "../../services/tripServices";
import { Link } from "react-router-dom";
import { IMAGE_BASE_URL } from "../../config";


export default function Trips() {
    const [trips, setTrips] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getAllTrips().then(data => {
            setTrips(data);
            setLoading(false);
        }).catch(err => {
            console.error("Failed to fetch trips:", err);
        });
    }, []);

    const handleDelete = (tripId) => {
        const conf = window.confirm("Are you sure you want to delete this trip?");
        if (!conf) {
            return;
        }
        deleteTrip(tripId).then(() => {
            setTrips(trips.filter(trip => trip.id !== tripId));
            alert("Trip deleted successfully!");
        }).catch(err => {
            console.error("Failed to delete trip:", err);
        });
    };

    return (
        <section className="trips">
            <header className="trips-header">
                <h1>Trips</h1>
                <Link to="/admin/trips/new" className="btn-primary">+ New Trip</Link>
            </header>


            <div className="trip-grid">
                {trips && trips.map((trip, i) => (
                    <article className="trip-card" key={i}>
                        <img src={`${IMAGE_BASE_URL}/${trip.image}`} crossOrigin="anonymous" />                      
                        <div className="trip-card-top">
                            <h3>{trip.title}</h3>
                            <span className={`status active`}>{trip.category}</span>
                        </div>
                        <p className="meta">📍 {trip.location}</p>
                        <p className="meta">$ {trip.price}</p>
                        <div className="flex row gap-10">
                            <button><Link to={`/admin/trips/edit/${trip.id}`} className="btn-secondary">Edit</Link></button>
                            <button onClick={() => handleDelete(trip.id)} className="btn-danger">Delete</button>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}